/**
 * @ngdoc controllers
 * @memberof mercury.modules.qa.bepoz
 * @name QaBepozProductSummaryCtrl
 * @description A report that replicates the Product summary from the Bepoz back office
 */
angular.module('mercury.modules.qa.wizbang')
.controller('QaWizbangPeriodendCtrl', ["$filter", "reporttime", "$q", "$scope", "$http", "$stateParams", "title", "settings", function($filter, reporttime, $q, $scope, $http, $stateParams, title, settings) {
  title.set('Period End Rport');

  $scope.loading = $http.get(settings.apiHost + '/r/PosQaWizbangSalesSaleCategory', {
    params: {startTime: reporttime.start(), endTime: reporttime.end()}});

  $scope.loading.then(function(response) {
    $scope.allLines = response.data;
  });

}]);
